import AbstractRange from "@/core/types/AbstractRange";

/**
 * Диапазон числовых значений (включая дробные)
 */
class NumericRange extends AbstractRange<number> {
  constructor(start: number | null = null, end: number | null = null) {
    super(start, end);
  }

  /**
   * Валидация диапазона числовых значений
   * @protected
   */
  protected _validate(): void {
    super._validate();

    if (this._start !== null && typeof this._start !== 'number') {
      throw new Error('Start must be a number');
    }
    if (this._end !== null && typeof this._end !== 'number') {
      throw new Error('End must be a number');
    }
  }

  static fromServer(numericRangeData, result = new NumericRange()) {
      return super.fromServer(numericRangeData, result);
  }
}

export default NumericRange;
